import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, SimpleChanges } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { QuoteOverviewModel } from '../../models/interpretation.model';
import { QuoteService } from '../../quote-service.service';
import { UserService } from '../../../../shared/services/user.service';

@Component({
  selector: 'quote-container',
  templateUrl: './quote-container.component.html',
  styleUrls: ['./quote-container.component.scss']
})
export class QuoteContainerComponent implements OnInit, OnDestroy {

  @Input() inspectionId: number;
  @Input() getQuotes = false;
  
  @Input() recommmendationID: number;
  @Output() selectedQuoteIdChanged: EventEmitter<number> = new EventEmitter();
  quotes: QuoteOverviewModel[] = [];
  selectedQuoteId: number = 0;
  addingQuote: boolean = false;
  isInspector: boolean = false;
  isInterpreter: boolean = false;

  constructor(private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _quotes: QuoteService,
  private _user: UserService) { }

  ngOnInit() {
    this.checkPermissions();
    this.getAllQuotes();
  }
  ngOnDestroy(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.recommmendationID = changes.recommmendationID.currentValue;
    this.getAllQuotes();
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case "Inspectors":
              this.isInspector = true;
              break;
            case "Interpreters":
            case "Super User":
            case "Administrator":
              this.isInterpreter = true;
              this.isInspector = true;
              break;
          }
        })
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  setSelectedQuoteId(quoteId: number) {
    this.selectedQuoteId = quoteId;
    this.selectedQuoteIdChanged.emit(quoteId);
  }

  getRecommendationIds(): number[] {
    let quote = this.quotes.find(q => q.QuoteId == this.selectedQuoteId);
    if (quote == null)
      return [];
    return quote.RecommendationIds;
  }

  getRecommendationList(): any[] {
    let quote = this.quotes.find(q => q.QuoteId == this.selectedQuoteId);
    if (quote == null)
      return [];
    return quote.Recommendations;
  }

  UpdateRecom(data){
    if(data == true)
    {
      this.getAllQuotes();
    }
  }

  addQuote() {
    this.addingQuote = true;
    this._interp.addQuote(this.inspectionId).subscribe(r => {
      if (r.m_Item1 > 0) {
        this._notify.success('Added', r.m_Item2);
        this.getAllQuotes(r.m_Item1);
        this.addingQuote = false;
      } else {
        this._notify.error('Error', 'Failed to add the new quote. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Error', 'Unable to add a new quote. Please contact TrackTreads support. ')
      console.error(err);
      this.addingQuote = false;
    });
  }

  getAllQuotes(quoteId?: number) {
    this._quotes.getQuoteOverviewsHttp(this.inspectionId).subscribe(r => {
      this.quotes = r;
      if (this.selectedQuoteId > 0)
        this.setSelectedQuoteId(this.selectedQuoteId);
      else if (quoteId != null)
        this.setSelectedQuoteId(quoteId);
      else if (r.length > 0)
        this.setSelectedQuoteId(r[0].QuoteId);

    }, err => {
      console.error(err);
      this._notify.error('Error', 'Unable to load quotes. Please contact TrackTreads support. ')
    });
  }

}
